import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HTTP_SERVICE_URL } from './injection-tokens';
import { Endpoint } from './endpoint';
import { ResponseHandler } from './response-handler';


@NgModule({
    imports: [
        CommonModule,
        // HttpClientModule,
    ],
    exports: [],
    providers: [
        Endpoint,
    ],
})
/**
 * pcp HTTP extensions.
 * Provides injection token `HTTP_SERVICE_URL` for the base URL of the HTTP service.
 *
 * NOTE: does not import the `HttpClientModule` which may be imported only one.
 *       The `HttpClientModule` should be imported in the root module of the application.
 */
export class PcpHttpModule {
    static forRoot(httpServiceUrl: string): ModuleWithProviders<PcpHttpModule> {
        return {
            ngModule: PcpHttpModule,
            providers: [
                ResponseHandler,
                { provide: HTTP_SERVICE_URL, useValue: httpServiceUrl },
            ]
        }
    }
}
